<template>  
<div> <!-- root element start -->

    <div  class="row">
      <div v-if="loading == 0" class="col-12 mt-4">
        <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
      </div>
    </div>

    <div v-if="loading == 1" class="row">

      

      <div class="col-12">
          <div class="card border-0">
            <div class="card-header h5 bg-transparent border-0">Single User</div>
            <div class="card-body">

              <div class="row"><!--  command row -->
                <div class="col-12">
                  <button @click="sendPasswordReset" class="btn btn-primary" :disabled="passRestButton">Reset Password</button>
                </div>
              </div>
              
              <hr class="bg-dark">

              <div class="row"><!--  name row -->

                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Name</span>
                </div>

                <div class="col-md-6">
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label class="d-none d-md-block" for="exampleInputEmail1">First Name</label>
                      <input type="text" class="form-control" aria-describedby="emailHelp" placeholder="First Name" v-model="f_name">
                    </div>
                    <div class="form-group col-md-6">
                      <label for="exampleInputEmail1">Last Name</label>
                      <input type="text" class="form-control" aria-describedby="emailHelp" placeholder="Last Name" v-model="l_name">
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                </div>
                <div class="col-md-2  h-100 justify-content-center align-self-center">
                  <button v-if="nameButton == false" @click="sendNameChange" class="btn btn-success">{{ nameButtonText }}</button>
                </div>
              </div>

              <hr class="bg-dark">

              <div class="row"><!--  email row -->

                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Email</span>
                </div>

                <div class="col-md-4">
                  <div class="row">
                    <div class="form-group col-12">
                      <label class="d-none d-md-block" for="exampleInputEmail1">Email</label>
                      <input type="text" class="form-control" aria-describedby="emailHelp" placeholder="Email" v-model="email">
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                </div>
                <div class="col-md-2  h-100 justify-content-center align-self-center">
                  <button v-if="emailButton == false" class="btn btn-success" @click="sendEmailChange">Save Email</button>
                </div>
              </div>

              <hr class="bg-dark">

              <div class="row"><!--  status row -->
                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Status</span>
                </div>

                <div class="col-md-4">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" id="exampleRadios1" value="0" v-model="status">
                        <label class="form-check-label" for="exampleRadios1">
                          Active
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" id="exampleRadios2" value="1" v-model="status">
                        <label class="form-check-label" for="exampleRadios2">
                          Suspended
                        </label>
                      </div>
                      <div class="form-check disabled">
                        <input class="form-check-input" type="radio" id="exampleRadios3" value="2" v-model="status">
                        <label class="form-check-label" for="exampleRadios3">
                          Closed
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                </div>
                <div class="col-md-2  h-100 justify-content-center align-self-center">
                  <button v-if="statusButton == false" class="btn btn-success" @click="sendStatusChange">Save Status</button>
                </div>
              </div>

              <hr class="bg-dark">

              <div class="row"><!--  role row -->
                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Role</span>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <label class="d-none d-md-block" for="exampleFormControlSelect1">Role</label>
                    <select class="form-control" id="exampleFormControlSelect1" v-model="role">
                      <option value="0">Sales Person</option>
                      <option value="1">Sales Manager</option>
                      <option value="2">Bid Manager</option>
                      <option value="3">Admin</option>

                    </select>
                  </div>
                </div>

                <div class="col-md-4">
                </div>
                <div class="col-md-2  h-100 justify-content-center align-self-center">
                  <button v-if="roleButton == false" class="btn btn-success" @click="sendRoleChange">Save Role</button>
                </div>
              </div>

              <hr class="bg-dark">



              <div v-if="role == 0" class="row"><!--  if user, sales manager row -->
                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Manager</span>
                </div>

                <div class="col-md-8">
                  <div class="row">

                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-12">
                          <label>Current Manager(s)</label>
                        </div>

                        <ul class="list-group list-group-flush col-12">
                          <li v-for="sm1 in smName" class="list-group-item">{{ sm1.name }} <i v-if="sm1.id != '0'" @click="deleteManager(sm1.rel)" class="fa fa-times text-danger" aria-hidden="true"></i></li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label for="exampleFormControlSelect1">Add Manager</label>

                      <div class="input-group">
                        <select class="form-control" id="exampleFormControlSelect1" v-model="smAssign">
                          <option value="n">Select a Manager</option>
                          <option v-for="(sm, index) in smList" :value="sm.id">{{sm.f_name}} {{sm.l_name}}</option>
                        </select>
                        <div class="input-group-append">
                          <button class="btn btn-outline-secondary" @click="addManager(smAssign)" type="button">Add</button>
                        </div>
                      </div>

                    </div>
                  </div>
                  
                </div>

                <div class="col-md-2">
                </div>

              </div>



            </div>
          </div>
      </div>
    </div>


</div> <!-- root element end -->
</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/admin-user-store.js'


// import catMain from '../InstComponents/CategoryComponents/category-main.vue'


export default {
  store,
  data: function () {
    return { 
      loading: 0,
      smList: [],
      smName: [],
      smAssign: 'n',
      nameButtonText: "Save Name",
      passRestButton: false,
      userDataVar: [],
      userDataCon: [],
      f_name: '',
      l_name: '',
      email: '',
      status: '',
      role: '',
    }
  },
  computed: {
    prop1 () { return this.$store.state.prop1 },
    nameButton: function(){
      var _this = this;
      if((_this.f_name != _this.userDataCon.f_name || _this.l_name != _this.userDataCon.l_name) && _this.f_name != '' &&  _this.f_name != null && _this.l_name != ''&&  _this.l_name != null) {
        return false;
      } else {
        return true;
      }
    },
    emailButton: function(){
      var _this = this;
      if(_this.email != _this.userDataCon.email && _this.email != '' &&  _this.email != null) {
        return false;
      } else {
        return true;
      }
    },
    statusButton: function(){
      var _this = this;
      if(_this.status != _this.userDataCon.status && _this.status != '' &&  _this.email != status) {
        return false;
      } else {
        return true;
      }
    },
    roleButton: function(){
      var _this = this;
      if(_this.role != _this.userDataCon.role && _this.role != '' &&  _this.role != null) {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    
  },
  mounted() {
    this.getUserInfo(this.prop1);
    this.getAllSMs();
  },
  methods: {
    changeRightView(name, prop1, prop2) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2 }); },
    getUserArray() { this.$store.dispatch("getAllUsers"); },
    getAllSMs() {
      var _this = this;
      axios.get('/admin/utility/getallactivesm')
        .then(function (response) {
        var a = response.data.data;
        _this.smList = a;
      });
    },
    getUserInfo(x) {
      var _this = this;
      _this.loading = 0;
      axios.get('/admin/utility/getindivuser/' + x)
        .then(function (response) {
        var a = response.data.data;
        if(a == null || a == ''){ var b = []; } else { var b = a; }
        _this.f_name = b.f_name;
        _this.l_name = b.l_name;
        _this.email = b.email;
        _this.status = b.status;
        _this.role = b.role;
        _this.smName = b.smName;
        _this.userDataCon = b;
        _this.loading = 1;
      });
    },
    sendPasswordReset() {
      var _this = this;
      _this.passRestButton = true;
      _this.$toastr.warning('Sending password reset email.', 'Please wait!')
      var x = _this.userDataCon.id
      axios.get('/admin/utility/sendrestlink/' + x)
        .then(function (response) {
          var msg = response.data.msg;
          _this.$toastr.remove()
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.passRestButton = false;
        })
        .catch(function (error) {
          var errors = error.response.data.errors;
          var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
          $.each(errors, function(key, value){ errorsHTML += '<li>' + value[0] + '</li>' });
          errorsHTML += '</ul></div>';
          _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
          _this.passRestButton = false;
        })
    },
    sendNameChange() {
      var _this = this;
      _this.$toastr.warning('Sending Name Change information.', 'Please wait!')
      var x = _this.userDataCon.id
      axios.post('/admin/utility/updateusersname', {
        id: x,
        f_name: _this.f_name,
        l_name: _this.l_name
      })
        .then(function (response) {
          var msg = response.data.msg;
          _this.$toastr.remove()
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.getUserArray();
          _this.getUserInfo(x)
        })
        .catch(function (error) {
          var errors = error.response.data.errors;
          var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
          $.each(errors, function(key, value){ errorsHTML += '<li>' + value[0] + '</li>' });
          errorsHTML += '</ul></div>';
          _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
          _this. nameButtonText = "Save Name";
        })
    },
    sendEmailChange() {
      var _this = this;
      _this.$swal({
        title: 'Are you sure?',
        text: "Changing a email status could affect their ability to login.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, change it!'
      }).then((result) => {
        if (result.value) {
          _this.$toastr.warning('Sending Email/Username Change information.', 'Please wait!')
          var x = _this.userDataCon.id
          axios.post('/admin/utility/updateemail', {
            id: x,
            email: _this.email,
          })
            .then(function (response) {
              var msg = response.data.msg;
              _this.$toastr.remove()
              _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
              _this.getUserArray();
              _this.getUserInfo(x)
            })
            .catch(function (error) {
              _this.$toastr.remove()
              var errors = error.response.data.errors;
              var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
              $.each(errors, function(key, value){ errorsHTML += '<li>' + value[0] + '</li>' });
              errorsHTML += '</ul></div>';
              _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
            })
        }
      })
    },

    sendStatusChange() {
      var _this = this;
      _this.$swal({
        title: 'Are you sure?',
        text: "Changing a user's status could affect their ability to login.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, change it!'
      }).then((result) => {
        if (result.value) {
          _this.$toastr.warning('Sending Status Change information.', 'Please wait!')
          var x = _this.userDataCon.id
          axios.post('/admin/utility/updatestatus', {
            id: x,
            status: _this.status,
          })
            .then(function (response) {
              var msg = response.data.msg;
              _this.$toastr.remove()
              _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
              _this.getUserArray();
              _this.getUserInfo(x)
            })
            .catch(function (error) {
              _this.$toastr.remove()
              var errors = error.response.data.errors;
              var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
              $.each(errors, function(key, value){ errorsHTML += '<li>' + value[0] + '</li>' });
              errorsHTML += '</ul></div>';
              _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
            })
        }
      })
    },
    sendRoleChange() {
       var _this = this;
      _this.$toastr.warning('Sending Role Change information.', 'Please wait!')
      var x = _this.userDataCon.id
      axios.post('/admin/utility/updaterole', {
        id: x,
        role: _this.role,
      })
        .then(function (response) {
          var msg = response.data.msg;
          _this.$toastr.remove()
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.getUserArray();
          _this.getUserInfo(x)
        })
        .catch(function (error) {
          _this.$toastr.remove()
          var errors = error.response.data.errors;
          var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
          $.each(errors, function(key, value){ errorsHTML += '<li>' + value[0] + '</li>' });
          errorsHTML += '</ul></div>';
          _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
        })
    },
    addManager(x){
      var _this = this;
      var a = _this.userDataCon.id
      // check if there is a valid selection
      if(x == 'n' || x == '' || x == null) { return false; }
      // check if the selection already exists
      var isIn = 0;
      for (i = 0; i < _this.smName.length; i++) { 
        if(_this.smName[i].id == x) {
          isIn += 1
        }
      }
      if(isIn > 0 ) {
        _this.$swal({ type: 'error', title: 'Problem!', text: 'You cannot assign this user to a manager that they are already assigned to!', });
        return false;
      }
      _this.$toastr.warning('Sending User/Manager information.', 'Please wait!')
      axios.post('/admin/utility/addmanager', {
        id: _this.userDataCon.id,
        sm_id: x
      })
        .then(function (response) {
          var msg = response.data.msg;
          _this.$toastr.remove()
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.smAssign = 'n';
          _this.getUserInfo(a)
        })
        .catch(function (error) {
          _this.$toastr.remove()
          var errors = error.response.data.errors;
          var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
          $.each(errors, function(key, value){ errorsHTML += '<li>' + value[0] + '</li>' });
          errorsHTML += '</ul></div>';
          _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
        })
    },
    deleteManager(id) {
      var _this = this;
      _this.$swal({
        title: 'Are you sure?',
        text: "Are you sure? This manager will no longer be able to see this user's quotes.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          _this.$toastr.warning('Sending Manager Information.', 'Please wait!')
          var x = _this.userDataCon.id
          axios.post('/admin/utility/deletemanager', {
            id: x,
            rel_id: id,
          })
            .then(function (response) {
              var msg = response.data.msg;
              _this.$toastr.remove()
              _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
              _this.getUserInfo(x)
            })
            .catch(function (error) {
              _this.$toastr.remove()
              var errors = error.response.data.errors;
              var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
              $.each(errors, function(key, value){ errorsHTML += '<li>' + value[0] + '</li>' });
              errorsHTML += '</ul></div>';
              _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
            })
        }
      })
    }
  },    
  components:{
    ScalingSquaresSpinner
  },
  filters: {

  }
}
</script>
